export default {
      id: "like-usage",
      viewBox: "0 0 8 7",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#like",
      toString: function () {
        return this.url;
      }
    }